import { css } from '@emotion/react'
import { UserAnimatedPhoto } from 'components/content/memory/animatedPhoto/AnimatedPhoto'
import { SActionsWrapper, SWrapper } from './MemoryVideo.styled'
import { Icon } from 'components/icon'
import { AnimatedMemoryAction } from 'components/memory/animatedMemoryAction/AnimatedMemoryAction'
import { SelectedMemory, useSingingPortraitSongName } from 'components/memory/MemoryUtils'
import { ToggleAudioButton } from 'components/toggleAudioButton/ToggleAudioButton'
import { useTranslation } from 'next-i18next'
import { ReactNode, useState } from 'react'

export function MemoryVideo(props: {
  memory?: SelectedMemory
  isPublic?: boolean
  onChangePhotoOrSong?: () => void
  roundCorners?: boolean
  muteButtonPosition?: 'default' | 'top-right'
  hideChangeButton?: boolean
  customPlaceholder?: ReactNode
  noPlaceholderAbsolutePosition?: boolean
}) {
  const { muteButtonPosition = 'default' } = props
  const { t } = useTranslation('memory')
  const [muted, setMuted] = useState(true)

  const songName = useSingingPortraitSongName(props.memory)

  return (
    <SWrapper>
      <UserAnimatedPhoto
        memory={props.memory}
        isPublic={props.isPublic}
        hideOriginalImage
        muted={muted}
        borderRadius={props.roundCorners ? 12 : undefined}
        customPlaceholder={props.customPlaceholder}
        noPlaceholderAbsolutePosition={props.noPlaceholderAbsolutePosition}
      />

      <SActionsWrapper className={muteButtonPosition}>
        <ToggleAudioButton label={songName} onClick={() => setMuted((m) => !m)} muted={muted} />
        {!props.isPublic && !props.hideChangeButton && (
          <AnimatedMemoryAction
            css={css`
              margin-top: 0.625rem;
            `}
            label={t('memory.singing.video_change_button')}
            onClick={props.onChangePhotoOrSong}
            icon={<Icon name="DocumentEdit" />}
          />
        )}
      </SActionsWrapper>
    </SWrapper>
  )
}
